import { render, staticRenderFns } from "./DoorBrokenWindowTiles.vue?vue&type=template&id=356846b4&scoped=true"
import script from "./DoorBrokenWindowTiles.vue?vue&type=script&lang=ts"
export * from "./DoorBrokenWindowTiles.vue?vue&type=script&lang=ts"
import style0 from "./DoorBrokenWindowTiles.vue?vue&type=style&index=0&id=356846b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356846b4",
  null
  
)

export default component.exports